import isArray from 'lodash/isArray'
import { useQuery } from 'react-query'

import { useUmbrella } from '@modules-deprecated/app/umbrellas'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { getUmbrellaPaymentMethod } from '../query-api'

export const usePaymentMethod = () => {
  const { umbrella } = useUmbrella()
  const { data, isIdle, isLoading } = useQuery(
    [QueryKeys.UmbrellaPaymentMethod, umbrella?.id],
    () => getUmbrellaPaymentMethod(umbrella?.id as string),
    {
      enabled: !!umbrella?.id,
    },
  )

  return {
    data: isArray(data?.data) ? undefined : data?.data,
    isLoading: isIdle || isLoading,
  }
}
